import { render, staticRenderFns } from "./RawShipmentAdd.vue?vue&type=template&id=b4d7341c&"
import script from "./RawShipmentAdd.vue?vue&type=script&lang=js&"
export * from "./RawShipmentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RawShipmentAdd.vue"
export default component.exports